var _rect, _path, _path2, _path3, _path4, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.301453,
    width: 64,
    height: 64,
    rx: 18.6182,
    fill: "#E8F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 34.6602L33.4542 33.3845C33.7113 33.1677 34.0161 33.0149 34.3437 32.9387C34.6713 32.8624 35.0123 32.8649 35.3387 32.9459C35.6534 33.0118 35.9451 33.1599 36.1841 33.375C36.4231 33.5901 36.6009 33.8647 36.6995 34.1707L36.839 34.6578L38.422 33.7321C38.8023 33.5128 39.2409 33.4158 39.6782 33.454C40.1155 33.4923 40.5305 33.6641 40.8669 33.9461",
    stroke: "#00A3FA",
    strokeWidth: 1.77339,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5636 48.0105H20.7127C20.1572 48.0105 19.6244 47.7898 19.2316 47.397C18.8388 47.0042 18.6182 46.4715 18.6182 45.916V22.876",
    stroke: "#8AD0F4",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7531 43.8214H24.9022C24.3467 43.8214 23.8139 43.6008 23.4211 43.208C23.0283 42.8152 22.8076 42.2824 22.8076 41.7269V18.6869",
    stroke: "#8AD0F4",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.848 37.5378C45.848 38.0933 45.6273 38.6261 45.2345 39.0189C44.8417 39.4117 44.3089 39.6323 43.7534 39.6323H29.0916C28.5361 39.6323 28.0034 39.4117 27.6105 39.0189C27.2177 38.6261 26.9971 38.0933 26.9971 37.5378V18.6869C26.9971 18.1314 27.2177 17.5986 27.6105 17.2058C28.0034 16.813 28.5361 16.5923 29.0916 16.5923H39.7445C40.2996 16.5925 40.832 16.8129 41.2246 17.2053L45.235 21.2157C45.6274 21.6084 45.8479 22.1407 45.848 22.6959V37.5378Z",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30.5456,
    y1: 20.3742,
    x2: 36.9456,
    y2: 20.3742,
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 30.5456,
    y1: 23.8651,
    x2: 42.1819,
    y2: 23.8651,
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 30.5456,
    y1: 27.356,
    x2: 37.5274,
    y2: 27.356,
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementIcon);
export default __webpack_public_path__ + "static/media/management-icon.44c79ceceda2795f3cb4ce19f63773cd.svg";
export { ForwardRef as ReactComponent };